var APP, isMobile;
(isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent)),
    (APP = {
        init: function () {
            return $("header .top-message").length && $("body").addClass("with-message"), this.sliders(), this.megamenu(), this.products(), this.newsletter(), this.content(), this.menu(), this.wishlist(), this.dropdowns();
        },
        resizer: function () { },
        scroller: function () {
            var e;
            return (e = $(window).scrollTop()), e > 50 ? $("header").addClass("scroll") : $("header").removeClass("scroll"), e > $(window).height() / 2 ? $(".scrolltop").addClass("active") : $(".scrolltop").removeClass("active");
        },
        sliders: function () {
            var e;
            return (
                $.each($("section.main .slider"), function () {
                    var e;
                    return (e = { dots: !0, arrows: !0, fade: !0 }), null !== $(this).attr("data-autoplay") && (e.autoplay = !0), $(this).slick(e);
                }),
                $("body").on("click", "section.main .slide", function () {
                    return $(this).is("a") || $(this).is("button") ? void 0 : $(this).parents(".slider").slick("slickNext");
                }),
                $.each($("section.grey .slider"), function () {
                    var e;
                    return (e = { dots: !0, arrows: !1, fade: !0 }), null !== $(this).attr("data-autoplay") && (e.autoplay = !0), $(this).slick(e);
                }),
                $('section.grey .slider').on('afterChange', function(event, slick, currentSlide, nextSlide){
                    $(this).parents('section.grey').find('.inside').hide();
                    $(this).parents('section.grey').find('.inside[data-index='+ currentSlide +']').fadeIn(200);
                }),
                $("body").on("click", "section.grey .slide", function () {
                    return $(this).is("a") || $(this).is("button") ? void 0 : $(this).parents(".slider").slick("slickNext");
                }),
                $("section.latest .slider").slick({ arrows: !0, dots: !1, autoplay: !0, autoplaySpeed: 2e3, slidesToShow: 4, slidesToScroll: 1, responsive: [{ breakpoint: 768, settings: { slidesToShow: 2, slidesToScroll: 2 } }] }),
                $("section.latest-posts .slider").slick({
                    arrows: !0,
                    dots: !1,
                    slidesToShow: 3,
                    slidesToScroll: 1,
                    responsive: [
                        { breakpoint: 768, settings: { slidesToShow: 2, slidesToScroll: 1 } },
                        { breakpoint: 478, settings: { slidesToShow: 1, slidesToScroll: 1 } },
                    ],
                }),
                (e = new Instafeed({
                    get: "user",
                    userId: 286094443,
                    accessToken: "286094443.b6b1223.d649720eebae40ab955a9adf48ab2f0f",
                    resolution: "standard_resolution",
                    target: $("section.instagram .slider")[0],
                    limit: 5,
                    after: function () {
                        return $("section.instagram .slider").slick({
                            arrows: !0,
                            dots: !1,
                            slidesToShow: 5,
                            slidesToScroll: 1,
                            responsive: [
                                { breakpoint: 768, settings: { slidesToShow: 2, slidesToScroll: 1 } },
                                { breakpoint: 478, settings: { slidesToShow: 1, slidesToScroll: 1 } },
                            ],
                        });
                    },
                    template: '<div class="slide"><a href="{{link}}" target="_blank"><div class="lazyload thumb" data-bg="{{image}}"></div></a></div>',
                })),
                $("section.instagram").length && e.run(),
                $("section.journal-slider .slider").slick({ autoplay: !0, arrows: !0, dots: !1, fade: !0 })
            );
        },
        megamenu: function () {
            return (
                "block" === $(".close-menu").css("display")
                    ? $("#menu li a.parent").on("click", function () {
                        var e;
                        return (
                            (e = $(this).attr("data-menu")),
                            $(this).is(".hover")
                                ? (window.location = $(this).attr("href"))
                                : ($("a.parent.hover").removeClass("hover"),
                                    $(".menu-popup.active").removeClass("active"),
                                    $('.menu-popup[data-parent="' + e + '"]').addClass("active"),
                                    $(this).addClass("hover"),
                                    $("main").addClass("hover"),
                                    setTimeout(function () {
                                        return $("main").addClass("hover");
                                    }, 51)),
                            !1
                        );
                    })
                    : ($("#menu li a.parent").on("mouseenter", function () {
                        var e;
                        return (
                            (e = $(this).attr("data-menu")),
                            $('.menu-popup[data-parent="' + e + '"]').addClass("active"),
                            $(this).addClass("hover"),
                            $("main").addClass("hover"),
                            setTimeout(function () {
                                return $("main").addClass("hover");
                            }, 51)
                        );
                    }),
                        $("#menu li a.parent").on("mouseleave", function () {
                            var e, t;
                            return (
                                (t = $(this)),
                                (e = $(this).attr("data-menu")),
                                setTimeout(function () {
                                    return $(".menu-popup .container:hover").length ? void 0 : ($('.menu-popup[data-parent="' + e + '"]').removeClass("active"), t.removeClass("hover"), $("main").removeClass("hover"));
                                }, 50)
                            );
                        }),
                        $(".menu-popup .container").on("mouseleave", function () {
                            var e;
                            return $(this).parent().removeClass("active"), (e = $(this).parent().attr("data-parent")), $('[data-menu="' + e + '"]').removeClass("hover"), $("main").removeClass("hover");
                        })),
                $(".close-menu").on("click", function () {
                    var e;
                    return (e = $(this).parents(".menu-popup")), $('a.parent[data-menu="' + e.attr("data-parent") + '"]').removeClass("hover"), e.removeClass("active"), $("main").removeClass("hover"), !1;
                }),
                $("header .store-menu li button.search").on("click", function () {
                    const inputField = $(this).parent().find('input[type="text"]');
                    if ($(window).width() < 1024 && "" === inputField.val()) {
                        $(this).parent().toggleClass("show");
                        inputField.focus();
                        return !1;
                    } else {
                        inputField.addClass('input--disabled');
                    }
                }),
                // added so that search container can be used to close
                $('header .store-menu form input[type="text"]').on('click', function (event) {
                    event.stopPropagation();
                }),
                $("header .store-menu .search-container").on("click", function () {
                    $(this).parent().find('input[type="text"]').val('');
                    $(this).parent().toggleClass("show");
                })
            );
        },
        products: function () {
            var e, t;
            return (
                $.each($(".product-item.back .thumb"), function () {
                    var e, t;
                    return (t = $(this).attr("data-replace").replace("background-image: url(", "").replace(")", "")), (e = new Image()), (e.src = t);
                }),
                $("body").on("mouseenter", ".product-item .thumb", function () {
                    return $(this).next().addClass("hover");
                }),
                $("body").on("mouseleave", ".product-item .thumb", function () {
                    return $(this).next().removeClass("hover");
                }),
                $("body").on("mouseenter", ".product-item .title", function () {
                    return $(this).parent().prev().addClass("hover");
                }),
                $("body").on("mouseleave", ".product-item .title", function () {
                    return $(this).parent().prev().removeClass("hover");
                }),
                $("body").on("mouseenter mouseleave", ".product-item.back", function () {
                    var e, t;
                    return (t = $(this).find(".thumb")), (e = t.attr("style")), t.attr("style", t.attr("data-replace")), t.attr("data-replace", e);
                }),
                (e = $(".gallery-popup .slides").flickity({ pageDots: !1, contain: !0, imageLoaded: !0, wrapAround: !0 })),
                (t = e.data("flickity")),
                e.on("select.flickity", function () {
                    return $("section.product-details .slides").slick("slickGoTo", t.selectedIndex);
                }),
                $("section.product-details .gallery .zoom").on("click", function () {
                    return $("body").css("overflow", "hidden"), $(".gallery-popup").addClass("active"), !1;
                }),
                $("section.product-details .gallery-vertical .zoom").on("click", function () {
                    var e;
                    return $("body").css("overflow", "hidden"), (e = $(this).parent().index()), t.select(e), $(".gallery-popup .stat .current").text(e + 1), $(".gallery-popup").addClass("active"), !1;
                }),
                $("section.product-details .slides").slick({ dots: !0, arrows: !1 }),
                $("section.product-details .slides").on("beforeChange", function (e, s, i, a) {
                    return t.select(a), $(".gallery-popup .stat .current").text(a + 1);
                }),
                $(".gallery-popup .close").on("click", function () {
                    return $(".gallery-popup").removeClass("active"), $("body").css("overflow", "auto"), !1;
                }),
                $("section.product-details .tabs-nav li a").on("click", function () {
                    var e;
                    return (
                        $(this).parent().is(".active") ||
                        ((e = $(this).parent().index()),
                            $("section.product-details .tabs-nav li.active").removeClass("active"),
                            $("section.product-details .tabs-tabs .tab.active").removeClass("active"),
                            $("section.product-details .tabs-tabs .tab").eq(e).addClass("active"),
                            $(this).parent().addClass("active")),
                        !1
                    );
                }),
                $("section.product-details .inside").hcSticky({ stickTo: ".sticky-parent", top: $("header .top-message").length ? $("header").outerHeight() - 40 : $("header").outerHeight() })
            );
        },
        newsletter: function () {
            return (
                Cookies.get("hambledon_cookies") ||
                setTimeout(function () {
                    return $("#signup-popup").addClass("active");
                }, 1e4),
                $("#signup-popup .close").on("click", function () {
                    return $("#signup-popup").removeClass("active"), Cookies.set("hambledon_cookies", "yes", { expires: 7 }), !1;
                }),
                $(".signup-open").on("click", function () {
                    return $("#signup-popup").addClass("active"), !1;
                }),
                $("#signup-popup form, footer .newsletter").on("submit", function (e) {
                    return (
                        e.preventDefault(),
                        $(this).addClass("sent"),
                        $("body.template-index").length && ($(this).is(".newsletter") ? ga("send", "event", "Contact", "Sign Up", "homepagebox") : ga("send", "event", "Contact", "Sign Up", "homepagepopup")),
                        $("body.template-collection").length && ga("send", "event", "Contact", "Sign Up", "categorybox"),
                        $("body.template-product").length && ga("send", "event", "Contact", "Sign Up", "productbox"),
                        $.ajax({ url: "//thehambledon.us4.list-manage.com/subscribe/post?u=a844fbeab2f21400dcab1eecd&amp;id=65c0092d5e", type: "post", data: $(this).serialize() }),
                        !1
                    );
                }),
                $(".compet-form").on("submit", function (e) {
                    return e.preventDefault(), $(this).addClass("sent"), $.ajax({ url: "//thehambledon.us4.list-manage.com/subscribe/post?u=a844fbeab2f21400dcab1eecd&amp;id=6bcc071c7e", type: "post", data: $(this).serialize() }), !1;
                })
            );
        },
        content: function () {
            return (
                $(".video .play").on("click", function () {
                    return ($(this).parent().next()[0].src += "?autoplay=1"), $(this).parent().addClass("remove"), !1;
                }),
                $.each($("section.content .more.desc p"), function () {
                    return "" === $(this).text() ? $(this).css("padding-top", "20px") : void 0;
                }),
                $("#section-0").is(".main") || $(".shogun-root>.shg-c:first-child").find(".shogun-image-container").length ? $("header").css("border-bottom", "none") : void 0
            );
        },
        menu: function () {
            return (
                $.each($("#menu-mobile ul li"), function () {
                    return $(this).find("ul").length ? $(this).children("a").find("span").addClass("plus") : void 0;
                }),
                $("#menu-mobile a span").on("click", function () {
                    return $(this).parent().parent().is(".open")
                        ? ($(this).parent().parent().removeClass("open"), !1)
                        : ($(this).parent().parent().addClass("open"),
                            $(this).parent().parent().prev().is(".open") && $(this).parent().parent().prev().removeClass("open"),
                            $(this).parent().parent().next().is(".open") && $(this).parent().parent().next().removeClass("open"),
                            !1);
                }),
                $("#menu-mobile .overlay").on("click", function () {
                    return $("body").removeClass("menu-mobile-on");
                }),
                $("header .mobile-menu").on("click", function () {
                    return $("body").addClass("menu-mobile-on"), !1;
                }),
                $("header .store-menu li.cart").on("click", function (e) {
                    return e.preventDefault(), $(this).toggleClass("active");
                }),
                isMobile
                    ? $.each($(".menu-popup"), function () {
                        var e, t, s;
                        return $(this).find(".title")
                            ? ((t = $('[data-menu="' + $(this).attr("data-parent") + '"]')),
                                (s = t.find("span").text() + " Homepage"),
                                (e = t.attr("href")),
                                $(this)
                                    .find(".col-14-sm")
                                    .children()
                                    .prepend('<div class="col-24-sm"><ul><li><a href="' + e + '">' + s + "</a></li></ul></div>"))
                            : void 0;
                    })
                    : void 0
            );
        },
        wishlist: function () {
            var e, t, s, i;
            return (
                $("body").on("click", ".product-item .wish, .wish a", function () {
                    var e, t, s;
                    return (
                        (e = Cookies.get("hambledon_wishlist")),
                        (s = e ? JSON.parse(e) : []),
                        $(this).parent().is(".wish")
                            ? ((t = {
                                url: window.location.href,
                                title: $("section.product-details h1").text(),
                                brand: $(".sub a").text(),
                                price: $("section.product-details .price").html().trim(),
                                image1: $("section.product-details .image").eq(0).find("img").attr("src"),
                                image2: $("section.product-details .image").eq(1).find("img").attr("src"),
                            }),
                                $("section.product-details").find(".wish").removeClass("wish").addClass("wish-remove").find("a").html("Remove from wishlist <i></i>"),
                                $('.product-item[productId="' + $(this).attr("productId") + '"] .wish').addClass("wish-remove"))
                            : ((t = {
                                url: $(this).parent().find(".title").attr("href"),
                                title: $(this).parent().find(".title").text(),
                                brand: $(this).parent().find(".brand").text(),
                                price: $(this).parent().find(".price").html().trim(),
                                image1: $(this).parent().prev().attr("data-bg"),
                                image2: $(this).parent().prev().attr("data-bg2"),
                            }),
                                $(this).addClass("wish-remove")),
                        s.push($(this).attr("productId")),
                        Cookies.set("hambledon_wishlist", JSON.stringify(s), { expires: 7 }),
                        Cookies.set("hambledon_wishlist_" + $(this).attr("productId"), JSON.stringify(t), { expires: 7 }),
                        !1
                    );
                }),
                $(".products.wishlist").length &&
                ((e = Cookies.get("hambledon_wishlist")),
                    e && (i = JSON.parse(e)),
                    i && i.length
                        ? ((t = ""),
                            $.each(i, function (e, s) {
                                var i, a;
                                return (
                                    (a = JSON.parse(Cookies.get("hambledon_wishlist_" + s))),
                                    (t += '<div class="col-12-xs col-6-sm">'),
                                    (i = a.image2 ? "product-item back" : "product-item"),
                                    (t += ' <div class="' + i + '">'),
                                    (t += '<a href="' + a.url + '" class="lazyload thumb" data-bg="' + a.image1 + '" data-replace="background-image: url(' + a.image2 + ')"></a>'),
                                    (t += '<div class="content">'),
                                    (t += '<a href="' + a.url + '" class="title">' + a.title + "</a>"),
                                    (t += '<div class="brand">' + a.brand + "</div>"),
                                    (t += '<div class="price">' + a.price + "</div>"),
                                    (t += ' <a href="" class="wish-remove" productId=' + s + "></a></div></div></div>")
                                );
                            }),
                            $(".products.wishlist").html(t))
                        : $("h2 + .more.desc").css("display", "block")),
                $(".product-item").length &&
                $.each($(".product-item"), function () {
                    var t;
                    return (
                        (t = $(this).find(".wish-action").attr("productId")),
                        (e = Cookies.get("hambledon_wishlist")),
                        e && (i = JSON.parse(e)),
                        i && i.length && -1 !== i.indexOf(t) ? $(this).find(".wish-action").removeClass("wish").addClass("wish-remove") : void 0
                    );
                }),
                $("section.product-details").length &&
                ((s = $("section.product-details").find(".wish a").attr("productId")),
                    (e = Cookies.get("hambledon_wishlist")),
                    e && (i = JSON.parse(e)),
                    i && i.length && -1 !== i.indexOf(s) && $("section.product-details").find(".wish").removeClass("wish").addClass("wish-remove").find("a").html("Remove from wishlist <i></i>")),
                $("body").on("click", ".product-item .wish-remove", function () {
                    var t;
                    return (
                        (e = Cookies.get("hambledon_wishlist")),
                        (i = JSON.parse(e)),
                        (s = $(this).attr("productId")),
                        s || (s = $(this).find("a").attr("productId")),
                        (t = i.indexOf(s)),
                        i.splice(t, 1),
                        Cookies.remove("hambledon_wishlist_" + s),
                        Cookies.set("hambledon_wishlist", JSON.stringify(i), { expires: 7 }),
                        "/pages/wishlist" === window.location.pathname
                            ? (window.location.href = "/pages/wishlist")
                            : ($(this).removeClass("wish-remove").addClass("wish"),
                                $(this).find("a").length && ($(this).find("a").html("Add to wishlist <i></i>"), $('.product-item[productId="' + $(this).find("a").attr("productId") + '"] .wish').removeClass("wish-remove"))),
                        !1
                    );
                })
            );
        },
        dropdowns: function () {
            return (
                $(".dropdown").on("click", function () {
                    $('.dropdown--show').not(this).removeClass('dropdown--show');
                    return $(window).width() < 480 ? $(this).toggleClass('dropdown--show') : void 0;
                }),
                $('.dropdown').on('mouseenter', function () {
                    return $(window).width() > 479 ? $(this).not('.dropdown--show').addClass('dropdown--show') : void 0;
                }),
                $('.dropdown').on('mouseleave', function () {
                    return $(window).width() > 479 ? $(this).removeClass('dropdown--show') : void 0;
                })
            );
        },
    }),
    (function () {
        APP.init(), $(window).resize(APP.resizer), $(window).scroll(APP.scroller);
    })();



// $(window).on('load', function() {
//               setTimeout(function() {
//         var iframes = $("#trustpilot-widget-trustbox-0-wrapper iframe");
//           var iframe;
//                 console.log(iframes, iframe);
//           if (iframes.length){	
//            iframe = iframes[0]; 
//           }
//           console.log(iframes, iframe);
//           console.log('outerheight', iframe.innerHeight());
//             return (
//                 iframe ? iframe.onload = function() {
//         				return function() { 
//                       	console.log('outerheight', $(this).height);
//                       	console.log('innerheight', $(this).contentWindow.document.body.scrollHeight);
//                     }
//     			}

//               :
//              void 0
//             );
//     }, 2000);

// });